// extracted by mini-css-extract-plugin
module.exports = {"Cursor":"Cursor_Cursor__guljw","caretIcon":"Cursor_caretIcon__EnAFr","grabText":"Cursor_grabText__jU6kk"};